import { createContext } from 'react';

const errorsContext = createContext();

export default errorsContext;
